import { css } from "@emotion/react";

export const card = css`
  display: flex;
  align-items: center;
  gap: 4px;
  @media (min-width: 600px) {
    gap: 16px;
  }
`;

export const icon = css`
  width: 56px;
  height: 56px;
  @media (min-width: 600px) {
    width: 160px;
    height: 160px;
  }
`;

export const iconLarge = css`
  width: 96px;
  height: 96px;
  @media (min-width: 600px) {
    width: 200px;
    height: 200px;
  }
`;

export const title = css`
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;

  @media (min-width: 600px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const hex = css`
  margin-top: 8px;
  font-size: 10px;
  font-weight: 300;
  line-height: 16px;
  @media (min-width: 600px) {
    margin-top: 16px;
    font-size: 12px;
    line-height: 19.2px;
  }
`;

export const rgb = css`
  font-size: 10px;
  font-weight: 300;
  line-height: 16px;
  @media (min-width: 600px) {
    font-size: 12px;
    line-height: 19.2px;
  }
`;
